import { type UserProfiles } from "@lib/types";

export default function userIsSfcAdmin(
  userId: string,
  context: {
    userProfiles: UserProfiles;
    effectiveIsSfcAdmin: boolean;
    /** @deprecated Use effectiveIsSfcAdmin instead */
    underlyingUserIsSfcAdmin?: boolean;
  },
) {
  const { userProfiles } = context;
  const fallback =
    context.effectiveIsSfcAdmin ?? context.underlyingUserIsSfcAdmin ?? false;
  return userProfiles[userId]?.isSfcAdmin ?? fallback;
}
